function backButton() {
  this.generateBackButton = path => {
    let _referrerUri = this.parseURI(document.referrer);
    let _currentUri = this.parseURI(document.URL);
    if (_referrerUri.hostname === _currentUri.hostname) {
      if (path.length) {
        let slice = _referrerUri.pathname.slice(0, path.length);
        if (slice === path) {
          return document.referrer;
        } else {
          return false;
        }
      } else {
        return document.referrer;
      }
      return document.referrer;
    } else {
      return false;
    }
  };

  this.parseURI = uri => {
    var parser = document.createElement("a");
    parser.href = uri;
    return parser;
  };
}

document.addEventListener("DOMContentLoaded", event => {
  const BACK_BUTTON = new backButton();
  let backButtons = document.getElementsByClassName("backButton");

  for (let i = 0; i < backButtons.length; i++) {
    let backButton = backButtons[0];

    let pathname = backButton.dataset.pathname;

    let _backUrl = BACK_BUTTON.generateBackButton(pathname);

    if (_backUrl) {
      backButton.href = _backUrl;
      backButton.classList.add("active");
    }
  }
});
